<template>
  <div
    style="top: calc(60vh); min-height: 40vh;"
    class="w-full bg-slate-50 rounded-header dark:bg-[#27282a] dark:text-white"
  >
    <!-- Header -->
    <div
      class="w-full flex items-center justify-between pt-4 px-4 pb-2 rounded-header border-b-1 dark:border-neutral-700"
    >
      <div class="w-full inline-flex justify-between items-center">
        <div class="inline-flex w-1/3">
          <Ligne
            v-for="(line, kl) in extractLine()"
            :key="kl"
            :name="`${line}`"
            size="small"
            class="mx-1"
          />
        </div>

        <div class="text-xl font-bold text-center w-1/3">
          <span v-if="travel.duration.hours === 0">
            {{ travel.duration.minutes }}
            <span class="text-sm font-normal">min</span>
          </span>
          <span v-else class="font-medium">
            {{ travel.duration.hours }}h {{ travel.duration.minutes }}
            <span class="text-sm font-normal -ml-1">min</span>
          </span>
        </div>
        <div
          class="cursor-pointer dark:text-slate-50 w-1/3"
          alt="Supprimer le trajet en cours"
          @click="closeTravel()"
        >
          <svg
            class="absolute right-4 top-4"
            style="height: 22px; width: 22px;"
            fill="currentColor"
            xmlns:dc="http://purl.org/dc/elements/1.1/"
            xmlns:cc="http://creativecommons.org/ns#"
            xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
            xmlns:svg="http://www.w3.org/2000/svg"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
            xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 100 100"
          >
            <g transform="translate(0,-952.36218)">
              <path
                style="text-indent:0;text-transform:none;direction:ltr;block-progression:tb;baseline-shift:baseline;enable-background:accumulate;"
                d="M 73.33453,974.78503 50,998.11953 l -23.33452,-23.3345 -4.24265,4.2426 23.33454,23.33447 -23.33453,23.3346 4.24263,4.2426 L 50,1006.6048 l 23.33452,23.3345 4.24265,-4.2426 -23.33454,-23.3346 23.33453,-23.33447 -4.24263,-4.2426 z"
                fill-opacity="1"
                marker="none"
                visibility="visible"
                display="inline"
                overflow="visible"
              ></path>
            </g>
          </svg>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="w-full h-full pb-24 overflow-y-auto">
      <div class="w-full inline-flex justify-center items-center">
        <span
          class="bg-slate-100 border dark:bg-transparent rounded-full px-4 py-1 text-sm mt-4"
        >
          Départ à {{ formatTime(travel.departure.datetime).replace(":", "h") }}
          <span v-if="isTomorrow(travel.departure.datetime)">
            demain
          </span>
          <span v-else>
            le
            {{
              travel.departure.datetime
                .split("T")[0]
                .slice(5)
                .replace("-", "/")
            }}
          </span>
        </span>
      </div>

      <div
        v-for="(journey, kj) in travel.journey.filter(
          j =>
            Object.keys(j.arrival).length > 1 &&
            Object.keys(j.departure).length > 1 &&
            Object.keys(j.metadata).length > 1
        )"
        :key="kj"
      >
        <div class="my-2" v-if="kj > 0">
          <div
            class="w-full inline-flex justify-center items-center"
            v-if="journey.arrival.defaultDelay"
          >
            <span
              class="bg-slate-100 border dark:bg-transparent rounded-full px-4 py-1 text-sm"
            >
              {{ journey.arrival.defaultDelay }}min d'attente
            </span>
          </div>
        </div>

        <div class=" p-4 mb-2 rounded-lg">
          <div class="w-full inline-flex items-center justify-between">
            <div class="inline-flex">
              <Ligne
                :name="`${journey.metadata.line}`"
                size="small"
                class="mx-1"
              />
              <span class="text-m ml-1">{{ journey.departure.placeName }}</span>
            </div>
          </div>

          <div class="w-full inline-flex justify-between items-center">
            <div
              class="w-2 h-8 my-1 border-r-2 border-dashed"
              style="margin-left: 0.6rem"
              :style="`border-color: ${journey.metadata.lineColor};`"
            ></div>

            <div class="text-lg font-bold">
              <span v-if="journey.duration.hours !== '00'">
                {{ journey.duration.hours }}
                <span class="text-sm font-normal">h</span>
              </span>
              <span v-if="journey.duration.minutes !== '00'">
                {{ journey.duration.minutes }}
                <span class="text-sm font-normal">min</span>
              </span>
            </div>
          </div>

          <div class="w-full inline-flex items-center justify-between">
            <div class="inline-flex">
              <Ligne
                :name="`${journey.metadata.line}`"
                size="small"
                class="mx-1"
              />
              <span class="text-m ml-1">{{ journey.arrival.placeName }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="w-full inline-flex justify-center items-center mt-2 mb-6">
        <span
          class="bg-slate-100 border dark:bg-transparent rounded-full px-4 py-1 text-sm"
        >
          🎉 Arrivée prévue à
          {{ formatTime(travel.arrival.datetime).replace(":", "h") }}
          <span v-if="isTomorrow(travel.arrival.datetime)">
            demain
          </span>
          <span v-else>
            le
            {{
              travel.arrival.datetime
                .split("T")[0]
                .slice(5)
                .replace("-", "/")
            }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>
<!-- 
TODO: transformer  

🎉 Arrivée prévue à 09h09 le 2023-09-09

en 

🎉 Arrivée prévue à 09h09 demain
-->
<style type="text/css">
.rounded-header {
  border-top-left-radius: 2rem;
  border-top-right-radius: 2rem;
}
.border-b-1 {
  border-bottom-width: 1px;
}
.bg-gray {
  background-color: #eeeeee;
}
</style>

<script>
import Ligne from "@/components/Ligne.vue";

export default {
  name: "Travel",
  components: {
    Ligne
  },
  props: {
    travel: Object
  },
  methods: {
    formatTime(datetime) {
      return datetime.split("T")[1].slice(0, 5);
    },
    isSameDay(datetime) {
      return datetime.split("T")[0] == new Date().toISOString().split("T")[0];
    },
    isTomorrow(date) {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      date = new Date(date);

      return (
        date.getDate() === tomorrow.getDate() &&
        date.getMonth() === tomorrow.getMonth() &&
        date.getFullYear() === tomorrow.getFullYear()
      );
    },
    formatDuration({ hours, minutes }) {
      if (hours > 0) {
        return `${hours}h ${minutes} min`;
      }
      return `${minutes} min`;
    },
    extractLine() {
      const a = this.travel.journey.map(j => j.metadata.line).filter(Boolean);
      console.log({ a });
      return a;
    },
    closeTravel() {
      this.$store.commit("closeTravel");
    }
  }
};
</script>
